/** Minimal SF-Symbols-flavoured icon set, stroked to match macOS toolbars. */
const s = (p: { size?: number }) => ({
  width: p.size ?? 18, height: p.size ?? 18, viewBox: '0 0 16 16',
  fill: 'none', stroke: 'currentColor', strokeWidth: 1.4,
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
})

type P = { size?: number }

export const FolderIcon = (p: P) => (
  <svg {...s(p)}><path d="M1.6 4.2a1 1 0 0 1 1-1h3l1.2 1.5h6.6a1 1 0 0 1 1 1v6.1a1 1 0 0 1-1 1H2.6a1 1 0 0 1-1-1Z" /></svg>
)
export const NotesIcon = (p: P) => (
  <svg {...s(p)}><rect x="2.4" y="2" width="11.2" height="12" rx="1.6" /><path d="M5 5.6h6M5 8h6M5 10.4h3.6" /></svg>
)
export const TrashIcon = (p: P) => (
  <svg {...s(p)}><path d="M2.8 4.3h10.4M6.2 4.3V3.1a.8.8 0 0 1 .8-.8h2a.8.8 0 0 1 .8.8v1.2M4.3 4.3l.6 8.5a1 1 0 0 0 1 .9h4.2a1 1 0 0 0 1-.9l.6-8.5" /></svg>
)
export const ComposeIcon = (p: P) => (
  <svg {...s(p)}><path d="M13.2 7.6v4.6a1.2 1.2 0 0 1-1.2 1.2H3.8a1.2 1.2 0 0 1-1.2-1.2V4a1.2 1.2 0 0 1 1.2-1.2h4.6" /><path d="M11.4 2.4 13.6 4.6l-4.9 4.9-2.6.4.4-2.6Z" /></svg>
)
export const SearchIcon = (p: P) => (
  <svg {...s(p)}><circle cx="7.2" cy="7.2" r="4.3" /><path d="m10.4 10.4 2.7 2.7" /></svg>
)
export const ChecklistIcon = (p: P) => (
  <svg {...s(p)}><circle cx="3.6" cy="4.6" r="2" /><circle cx="3.6" cy="11.4" r="2" /><path d="M7.6 4.6h6M7.6 11.4h6" /></svg>
)
export const BoldIcon = (p: P) => (
  <svg {...s(p)} strokeWidth={1.7}><path d="M4.8 8h3.6a2.6 2.6 0 0 0 0-5.2H4.8V8Zm0 0h4.1a2.6 2.6 0 0 1 0 5.2H4.8V8Z" /></svg>
)
export const ItalicIcon = (p: P) => (
  <svg {...s(p)}><path d="M10.2 2.8H6.6m2.8 10.4H5.8M9.4 2.8 6.6 13.2" /></svg>
)
export const UnderlineIcon = (p: P) => (
  <svg {...s(p)}><path d="M4.4 2.6v5a3.6 3.6 0 0 0 7.2 0v-5M3.6 13.6h8.8" /></svg>
)
export const AaIcon = (p: P) => (
  <svg {...s(p)}><path d="M1.6 12.4 5 3.6l3.4 8.8M2.9 9.7h4.2" /><path d="M14.4 12.4V8.6a2 2 0 0 0-2-2h-.4a2 2 0 0 0-1.8 1.1M14.4 9.9h-2.2a1.7 1.7 0 0 0 0 3.4c1 0 2.2-.6 2.2-2" /></svg>
)
export const PinIcon = (p: P) => (
  <svg {...s(p)} strokeWidth={1.2}><path d="M9.6 1.9 14 6.3l-1.9.6-1 3.2-4.8-4.8 3.2-1ZM6.3 9.7 2.4 13.6M6.3 5.3 10.7 9.7" /></svg>
)
export const ChevronLeft = (p: P) => (
  <svg {...s(p)} strokeWidth={1.8}><path d="M10 2.8 4.8 8l5.2 5.2" /></svg>
)
export const SidebarIcon = (p: P) => (
  <svg {...s(p)}><rect x="2" y="3" width="12" height="10" rx="1.6" /><path d="M6.4 3v10" /></svg>
)
export const PlusIcon = (p: P) => (
  <svg {...s(p)}><path d="M8 3.2v9.6M3.2 8h9.6" /></svg>
)
export const ListBulletIcon = (p: P) => (
  <svg {...s(p)}><circle cx="3.2" cy="4.6" r=".9" fill="currentColor" /><circle cx="3.2" cy="11.4" r=".9" fill="currentColor" /><path d="M6.6 4.6h6.8M6.6 11.4h6.8" /></svg>
)
export const ListNumberIcon = (p: P) => (
  <svg {...s(p)} strokeWidth={1.2}><path d="M2.2 3.4h1v3.2M2 12.2h2.2L2 9.9h2.2M7 4.8h6.6M7 11.2h6.6" /></svg>
)
export const GoogleIcon = () => (
  <svg width="17" height="17" viewBox="0 0 18 18" aria-hidden>
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62Z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z" />
    <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z" />
  </svg>
)

export const TableIcon = (p: P) => (
  <svg {...s(p)}><rect x="2" y="3" width="12" height="10" rx="1.4" /><path d="M2 6.4h12M2 9.8h12M6.4 6.4V13M9.8 6.4V13" /></svg>
)
export const ImageIcon = (p: P) => (
  <svg {...s(p)}><rect x="2" y="3" width="12" height="10" rx="1.6" /><circle cx="5.9" cy="6.5" r="1.1" /><path d="m3 11.4 3-2.6 2.4 2 2-1.6 2.6 2.2" /></svg>
)
export const HighlightIcon = (p: P) => (
  <svg {...s(p)}><path d="M9.4 2.6 13.4 6.6l-5 5H5.2l-1.8-1.8Z" /><path d="M2.6 13.8h10.8" /></svg>
)
export const StrikeIcon = (p: P) => (
  <svg {...s(p)}><path d="M2.6 8h10.8" /><path d="M11.4 4.7C10.9 3.5 9.7 2.9 8.2 2.9c-1.8 0-3 .9-3 2.2 0 1 .6 1.7 2 2.2M4.6 11.2c.5 1.3 1.8 2 3.5 2 1.9 0 3.2-1 3.2-2.4 0-.9-.4-1.6-1.3-2" /></svg>
)
export const LinkIcon = (p: P) => (
  <svg {...s(p)}><path d="M6.6 9.4a2.6 2.6 0 0 0 3.8.2l2-2a2.6 2.6 0 0 0-3.7-3.7l-1.1 1.1" /><path d="M9.4 6.6a2.6 2.6 0 0 0-3.8-.2l-2 2a2.6 2.6 0 0 0 3.7 3.7l1.1-1.1" /></svg>
)
export const GridIcon = (p: P) => (
  <svg {...s(p)}><rect x="2.2" y="2.2" width="5" height="5" rx="1.2" /><rect x="8.8" y="2.2" width="5" height="5" rx="1.2" /><rect x="2.2" y="8.8" width="5" height="5" rx="1.2" /><rect x="8.8" y="8.8" width="5" height="5" rx="1.2" /></svg>
)
export const ListViewIcon = (p: P) => (
  <svg {...s(p)}><path d="M2.4 4h11.2M2.4 8h11.2M2.4 12h11.2" /></svg>
)
export const SortIcon = (p: P) => (
  <svg {...s(p)}><path d="M2.6 4.2h10.8M4.6 8h6.8M6.6 11.8h2.8" /></svg>
)
export const TagIcon = (p: P) => (
  <svg {...s(p)}><path d="M7.4 2.4H13a.6.6 0 0 1 .6.6v5.6l-5.4 5.4a.9.9 0 0 1-1.3 0L2.4 9.1a.9.9 0 0 1 0-1.3Z" /><circle cx="10.6" cy="5.4" r="1" /></svg>
)
export const QuoteIcon = (p: P) => (
  <svg {...s(p)}><path d="M3 12V8.4c0-2.3 1.2-3.9 3.2-4.4M9 12V8.4c0-2.3 1.2-3.9 3.2-4.4" /><path d="M3 8.4h3.2M9 8.4h3.2" /></svg>
)
export const CodeIcon = (p: P) => (
  <svg {...s(p)}><path d="m5.4 4.6-3 3.4 3 3.4M10.6 4.6l3 3.4-3 3.4" /></svg>
)
export const SpinnerIcon = (p: P) => (
  <svg {...s(p)} style={{ animation: 'spin .8s linear infinite' }}><path d="M8 2.2a5.8 5.8 0 1 1-4.1 1.7" /></svg>
)

export const AppleIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M16.36 12.78c.02-2.3 1.88-3.4 1.96-3.45-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.48.83-.72 0-1.83-.81-3.01-.79-1.55.02-2.98.9-3.78 2.28-1.61 2.8-.41 6.95 1.16 9.22.77 1.11 1.68 2.36 2.87 2.31 1.15-.05 1.59-.74 2.98-.74 1.39 0 1.78.74 2.99.72 1.24-.02 2.02-1.13 2.78-2.25.88-1.29 1.24-2.54 1.26-2.6-.03-.01-2.41-.93-2.43-3.7zM14.1 5.98c.64-.77 1.07-1.85.95-2.92-.92.04-2.03.61-2.69 1.38-.59.68-1.11 1.78-.97 2.83 1.03.08 2.07-.52 2.71-1.29z"/>
  </svg>
)

export const LockIcon = (p: P) => (
  <svg {...s(p)}><rect x="3" y="7" width="10" height="6.6" rx="1.5" /><path d="M5.4 7V5.2a2.6 2.6 0 0 1 5.2 0V7" /></svg>
)

export const HistoryIcon = (p: P) => (
  <svg {...s(p)}>
    <path d="M2.3 8a5.7 5.7 0 1 0 1.7-4.05" /><path d="M2.2 2.2v2.6h2.6" /><path d="M8 4.9V8l2.2 1.5" />
  </svg>
)
